module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-2-7.df75f4a2.png";